import { render, staticRenderFns } from "./expertTableView.vue?vue&type=template&id=fbf3a2f0&scoped=true&"
import script from "./expertTableView.vue?vue&type=script&lang=js&"
export * from "./expertTableView.vue?vue&type=script&lang=js&"
import style0 from "./expertTableView.vue?vue&type=style&index=0&id=fbf3a2f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf3a2f0",
  null
  
)

export default component.exports